import React from 'react';
import { Award } from 'lucide-react';
import { Input } from './ui/input';

export default function SignatureServices({ value = [], onChange, max = 3 }) {
  const services = [...(value || [])];
  while (services.length < max) services.push('');

  const update = (idx, val) => {
    const updated = [...services];
    updated[idx] = val;
    onChange(updated.filter(s => s.trim()));
  };

  return (
    <div className="space-y-3" data-testid="signature-services">
      <div className="flex items-center gap-2">
        <Award className="h-5 w-5 text-[#2DD4BF]" />
        <h3 className="font-manrope font-semibold text-[#0F2A44]">Top 3 Signature Services</h3>
      </div>
      <p className="text-xs text-[#4B5563]">What are the top services you want to be known for?</p>
      {services.slice(0, max).map((s, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="text-sm font-semibold text-[#2DD4BF] w-6">{i + 1}.</span>
          <Input
            value={s}
            onChange={(e) => update(i, e.target.value)}
            placeholder={`Signature service ${i + 1}`}
            className="flex-1"
            data-testid={`signature-service-${i}`}
          />
        </div>
      ))}
    </div>
  );
}
